import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "loading-icon" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["loading-overlay is-active", { 'is-full-page': _ctx.isFullPage }])
  }, [
    _createElementVNode("div", {
      class: "loading-background",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
    }),
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _hoisted_1
    ])
  ], 2)), [
    [_vShow, _ctx.active]
  ])
}